import React from 'react'
import { InputGuesser } from '@api-platform/admin'
import { CreateGuesser } from 'theme/components'

export const CurrencyCreate = (props) => (
  <CreateGuesser {...props} variant="outlined" redirect="list">
    <InputGuesser source="code" />
  </CreateGuesser>
)
